import Observable from './observable';
import map from './map';
export default function scan(reducer, initialValue, stream) {
    // tslint:disable-next-line:ter-prefer-arrow-callback
    return Observable.defer(function factory() {
        let currentValue = initialValue;
        return map(
        // tslint:disable-next-line:ter-prefer-arrow-callback
        function scanMap(value, index) {
            const updatedValue = reducer(currentValue, value, index);
            return (currentValue = updatedValue);
        }, stream);
    });
}
//# sourceMappingURL=scan.js.map